var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"className":"calendar_svg","d":"M13.066 1.172h-1.347v-.7a.469.469 0 0 0-.937 0v.7H4.219v-.7a.469.469 0 0 0-.937 0v.7H1.934A1.936 1.936 0 0 0 0 3.105v9.961A1.936 1.936 0 0 0 1.934 15h11.132A1.936 1.936 0 0 0 15 13.066V3.105a1.936 1.936 0 0 0-1.934-1.933zm-11.132.937h1.347v.469a.469.469 0 0 0 .938 0v-.469h6.563v.469a.469.469 0 0 0 .938 0v-.469h1.348a1 1 0 0 1 1 1v1.11H.938V3.105a1 1 0 0 1 .996-.996zm11.132 11.954H1.934a1 1 0 0 1-1-1V5.156h13.129v7.91a1 1 0 0 1-.997.997z"})));
}

Calendar.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = Calendar;

Calendar.default = Calendar;
